import { render } from "./Page7.vue?vue&type=template&id=1decbae6&scoped=true"
import script from "./Page7.vue?vue&type=script&lang=js"
export * from "./Page7.vue?vue&type=script&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=1decbae6&scoped=true&lang=css"

import exportComponent from "/Users/felipewalflan/Documents/Gitlab gen-t/_front/base-questionnaire/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1decbae6"]])

export default __exports__